import { ChangeEvent, ReactElement, useState } from "react";
import {
  ICasterProduction,
  IDelayMeltShop,
  IEventHistory,
  IProductionExtended,
  IState
} from "../../../types";
import { Paper, Tab, Tabs } from "@mui/material";
import DelayPanel from "../../interruptions/compoenents/delayPanel";
import TabPanel from "../../../components/tabPanel";
import { useSelector } from "react-redux";
import EquipmentLifePanel from "../lrf/equipmentLifePanel";
import CasterGeneralPanel from "./casterGeneralPanel";
import TundishTemperaturePanel from "./tundishTemperaturePanel";
import EventPanel from "./eventPanel";
import HeatChart from "../../production/components/heatChart";
import SamplePanel from "../../production/components/heatPanels/samplesPanel";
import RoundQualityPanel from "../../production/components/heatPanels/roundQualityPanel";
import { useFetch } from "../../../system/useFetch";
import CircularProgress from "@mui/material/CircularProgress";

interface IHeatInformationProps {
  productionItem: IProductionExtended;
  height?: number;
}

const CasterHeatInformation = ({ productionItem, height }: IHeatInformationProps): ReactElement => {
  const darkMode = useSelector((state: IState) => state.darkMode);
  const [value, setValue] = useState(0);
  const [selectedDelay, setSelectedDelay] = useState<IDelayMeltShop | null>(null);
  const { data: events } = useFetch<IEventHistory[]>(
    {
      module: "production",
      query: "getEventHistoryByProductionMachineID",
      payload: {
        productionMachineID: productionItem.productionMachineID
      }
    });

  //

  const handleChange = (_event: ChangeEvent<any>, newValue: number) => {
    setValue(newValue);
  };

  const heatData = productionItem as ICasterProduction;

  return (
    <Paper style={{ height }}>
      <Tabs
        value={value}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        centered={true}
        style={{ background: darkMode ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.2)" }}>
        <Tab label="General"/>
        <Tab label="Samples"/>
        <Tab label="Delays"/>
        <Tab label="Tundish Temp. Summary"/>
        <Tab label="Equipment Life"/>
        <Tab label="Event"/>
        <Tab label="Quality Round"/>
      </Tabs>
      <TabPanel value={value} index={0} style={{ padding: "1em" }}>
        <CasterGeneralPanel productionItem={productionItem}/>

        <div style={{ width: "100%", height: 100, marginTop: "1em" }}>
          <HeatChart productionData={productionItem} hideAxisTitle={true} selected={selectedDelay}/>
        </div>
      </TabPanel>

      <TabPanel value={value} index={1}>
        <SamplePanel samples={productionItem.samples.filter(x => !x.sampleType.code.startsWith("CT"))} steelCode={heatData.steel.code} zoneCode={heatData.zone.code}/>
      </TabPanel>

      <TabPanel value={value} index={2}>
        <DelayPanel delays={productionItem.delays as IDelayMeltShop[]} selected={selectedDelay} setSelected={d => setSelectedDelay(d as IDelayMeltShop)} />
      </TabPanel>

      <TabPanel value={value} index={3}>
        <TundishTemperaturePanel data={heatData.samples.filter(x => x.sampleType.code.startsWith("CT"))} />
      </TabPanel>

      <TabPanel value={value} index={4}>
        <EquipmentLifePanel data={heatData.equipmentLife} />
      </TabPanel>

      <TabPanel value={value} index={4}>
        {!events
          ? <div className="text-center"><CircularProgress /></div>
          : <EventPanel data={events} />
        }
      </TabPanel>

      <TabPanel value={value} index={5}>
        <RoundQualityPanel data={heatData.productionAggregates} />
      </TabPanel>

    </Paper>
  );
};

export default CasterHeatInformation;
